import { IBaseRequestGetPaged, IResource, IRole } from "./../../commons/interfaces";
import Helpers from "../../commons/helpers";
import IdentityClient from "./IdentityClient";
import { Constants } from "../../constants/constants";
import { IPagedList } from "../../commons/interfaces";

export interface IRequestGetPagedRole extends IBaseRequestGetPaged {
    organizationId?: string;
    clientId?: string;
    serviceCode?: string;
    roleLevel?: number;
    status?: number;
    type?: number;
}

export interface IRequestUpdateRole {
    serviceCode: string;
    status: number;
    roleName: string;
    type: number;
    roleLevel: number;
    description: string;
    organizationId: string;
    id: string;
    clientId: string;
    updateTime: number;
    resources: Resource[];
}

export interface Resource {
    resourceCode: string;
    permission: number;
    quota: number;
}

export type IRequestCreateRole = Omit<IRequestUpdateRole, "id" | "update">;

const RoleService = {
    async getAll(data: {
        type?: string;
        status?: number;
        clientId?: string;
        roleLevel?: string;
        serviceCode?: string;
        organizationId?: string;
    }): Promise<IRole[]> {
        const query = Helpers.handleFormatParams(data);
        const result = await IdentityClient().get(`${Constants.ApiPath.ROLE.GET_ALL}?${query}`);
        return result.data.result;
    },

    async getPaged(data: any): Promise<IPagedList<IRole>> {
        const query = Helpers.handleFormatParams(data);
        const result = await IdentityClient().get(`${Constants.ApiPath.ROLE.GET_PAGED}?${query}`);
        return result.data.result;
    },

    async getDetail(id: string): Promise<IRole> {
        const result = await IdentityClient().get(Constants.ApiPath.ROLE.GET_DETAIL + `/${id}`);
        return result.data.result;
    },

    async create(data: IRequestCreateRole) {
        const result = await IdentityClient().post(Constants.ApiPath.ROLE.CREATE, data);
        return result.data.result;
    },

    async update(data: IRequestUpdateRole) {
        const result = await IdentityClient().post(Constants.ApiPath.ROLE.UPDATE, data);
        return result.data;
    },

    async delete(data: any) {
        const result = await IdentityClient().delete(Constants.ApiPath.ROLE.DELETE, { data });
        return result.data;
    },

    async updateStatus(data: any) {
        const result = await IdentityClient().post(Constants.ApiPath.ROLE.UPDATE_STATUS, data);
        return result.data;
    },

    async countUser(id: string): Promise<number> {
        const result = await IdentityClient().get(Helpers.handleUrlJoin(Constants.ApiPath.ROLE.COUNT_USER, id));
        return result.data.result;
    },
};

export default RoleService;
